import { useField, useFormikContext } from "formik";
import {
  DebugForm,
  DisplayFormErrors,
  InputField,
  SelectField,
  VerticalForm,
} from "melco-shared-logic";
import { Button, FullWidthSpace, PlusIcon, Text } from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type DisplayGenerateViewerLinkFormProps = {
  callbackViewerLinkDetail: () => void;
};

export const DisplayGenerateViewerLinkForm: React.FC<
  DisplayGenerateViewerLinkFormProps
> = ({ callbackViewerLinkDetail }) => {
  const { t } = useTranslation();
  const [submitAction, , submitActionHelper] = useField<string>("submitAction");
  const { submitForm } = useFormikContext();
  const [isSubmitting, setSubmitting] = useState(false);

  const daysArr = [
    {
      label: t(
        "reporting.machinestatus.view.viewerlink.drawer.form.validity.options.30days"
      ),
      value: 30,
    },
    {
      label: t(
        "reporting.machinestatus.view.viewerlink.drawer.form.validity.options.60days"
      ),
      value: 60,
    },
    {
      label: t(
        "reporting.machinestatus.view.viewerlink.drawer.form.validity.options.90days"
      ),
      value: 90,
    },
    {
      label: t(
        "reporting.machinestatus.view.viewerlink.drawer.form.validity.options.forever"
      ),
      value: -1,
    },
  ];

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FullWidthSpace direction="vertical" size="middle">
        <Text>
          {t("reporting.machinestatus.view.viewerlink.drawer.message")}
        </Text>
        <div data-cy-id="validity">
          <SelectField
            name="days"
            label={t(
              "reporting.machinestatus.view.viewerlink.drawer.form.validity.label"
            )}
            options={daysArr.map((day) => {
              return {
                label: day.label!,
                value: day.value!,
              };
            })}
            optionFilterProp="label"
          />
        </div>

        <InputField
          name="password"

          autoComplete="off"
          placeholder={t(
            "reporting.machinestatus.view.viewerlink.drawer.form.password"
          )}
          type="password"
          //  autoComplete="current-password"
          info={t("reporting.machinestatus.view.viewerlink.drawer.form.info")}
        />
        {/* <GenerateViewerLinkButton viewId={viewId} /> */}

        <Button
          key="view-edit"
          loading={isSubmitting}
          type="primary"
          icon={<PlusIcon />}
          onClick={async () => {
            setSubmitting(true);
            submitActionHelper.setValue("viewerLink");
            submitForm()
              .then(() => {
                callbackViewerLinkDetail();
                setSubmitting(false);
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          {t("reporting.machinestatus.view.viewerlink.actions.add.button")}
        </Button>
      </FullWidthSpace>

      {false && <DebugForm />}
    </VerticalForm>
  );
};
